// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewsSearchBox_container__T3Pzm","resultItem":"ReviewsSearchBox_resultItem__hvAWC"};